const styles = {
  viewer: {
    width: "100vw",
    height: "100%",
    background: "#040404",
    position: "fixed",
    top: 0,
    zIndex: 1000002,
    display: "flex",
    flexDirection: "column",
  },
  topContainer: {
    boxSizing: "border-box",
    backgroundColor: "#040404",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "56px",
    paddingLeft: "15px",
    paddingRight: "15px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
    position: "relative",
    "@media screen and (orientation: landscape)": {
      marginTop: "12px",
      marginBottom: "12px",
    },
  },

  counter: {
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    display: "inline-block",
  },
  videoContainer: {
    "@media screen and (orientation: portrait)": {
      height: "60%",
      marginTop: "30px",
    },
    "@media screen and (orientation: landscape)": {
      height: "60%",
      marginTop: "10px",
    },

    display: "flex",
    alignItems: "center",
    "& > iframe": {
      width: "100%",
      height: "100%",
    },
  },
  awsVideo: {
    height: "auto",
    width: "100%",
    objectFit: "contain",
  },
  videoTitle: {
    "@media screen and (orientation: portrait)": {
      left: "24px",
      marginTop: "10px",
      marginLeft: "20px",
      color: "white",
      fontFamily: "CircularStd",
      fontSize: "20px",
      fontWeight: "500",
      letterSpacing: "0",
      lineHeight: "25px",
      overflowWrap: "anywhere",
    },
    "@media screen and (orientation: landscape)": {
      display: "none",
    },
    "@media screen and  (min-width : 768px) and (orientation: portrait)": {
      left: "24px",
      marginTop: "10px",
      marginLeft: "20px",
      color: "white",
      fontFamily: "CircularStd",
      fontSize: "20px",
      fontWeight: "500",
      letterSpacing: "0",
      lineHeight: "25px",
      display: "block",
      overflowWrap: "anywhere",
    },
    "@media screen and (min-width : 768px) and (orientation: landscape)": {
      left: "24px",
      marginTop: "10px",
      color: "white",
      fontFamily: "CircularStd",
      fontSize: "20px",
      fontWeight: "500",
      letterSpacing: "0",
      lineHeight: "25px",
      display: "block",
      overflowWrap: "anywhere",
    },
  },

  navigate: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    top: "90vh",
    width: "calc(100% - 56px)",
    marginLeft: "28px",
    marginRight: "28px",
  },
  caret: {
    position: "relative",
    top: "6px",
    display: "inline-block",
  },

  rotate: {
    top: "-3px",
    transform: "rotate(180deg)",
  },

  description: {
    position: "fixed",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.9)",
    zIndex: 1000006,
    overflowY: "scroll",
    top: 0,
    right: 0,
    transition: "0.3s all ease",
    width: "33.3%",
    "@media screen and (max-width : 767px) and (orientation: portrait)": {
      width: "100%",
    },
  },

  closeIcon: {
    position: "absolute",
    top: "10px",
    right: "10px",

    zIndex: 1000007,
  },

  descriptionText: {
    position: "absolute",
    top: "84px",
    padding: "0 25px",
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "24px",
  },
};

export default styles;
